<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">商务对接</p>
        <p>佰付美营销合作平台，专为您解答各类问题</p>
      </div>
    </div>
    <section>
      <div class="mainDivWidth coopemain">
        <h3 class="sectionTitle">商务对接</h3>
        <div class="callservice flexDiv">
          <div class="callmain coopemainbgtwo">
            <div>
              <p><img src="static/img/businesspic/busin/icon01.png" alt="">商务咨询</p>
              <!-- <p class="smaltxt inten mar">负责人联系电话：17808172744</p> -->
              <p class="smaltxt inten mar">如果您有商务合作需求或疑问，还可以将需求或疑问发送至下方邮箱</p>
              <p class="smaltxt inten mar">邮箱地址：weinashangwu@epaynfc.com</p>
            </div>
            <div> 
              <p><img src="static/img/businesspic/busin/icon02.png" alt="">邮箱模板</p>
              <p class="smaltxt inten mar">邮箱标题：简述问题以便我们快速核实</p>
              <p class="smaltxt inten mar">内容说明：详细描述您的需求或者遇到的问题，并留下您的联系方式，以便我们能及时联系到您，给予反馈</p>
              <p class="smaltxt inten mar">截图：您遇到相关问题的截图</p>
            </div>
          </div>
          <img src="static/img/businesspic/busin/busi.png" alt="">
        </div>
      </div>
    </section>
  
    <section>
      <div class="mainDivWidth coopemain">
        <h3 class="sectionTitle">联系方式</h3>
        <div class="callservice flexDiv">
          <img src="static/img/businesspic/call/call.png" alt="">
          <div class="callmain coopemainbgone">
            <div>
              <p><img src="static/img/businesspic/call/icon01.png" alt="">客服电话</p>
              <p class="numbers inten">400-770-7768</p>
              <p class="smaltxt inten">值班时间：周一到周五09:00-18:00（法定节假日除外）</p>
            </div>
            <div>
              <p><img src="static/img/businesspic/call/icon02.png" alt="">公司地址</p>
              <p class="smaltxt inten">陕西省西安市雁塔区天谷七路国家数字出版基地A座404</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'cooperate',
  data:function(){
    return {
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">
    @import "../../assets/css/cooperate";
</style>



// WEBPACK FOOTER //
// src/pages/cooperatePage/cooperate.vue